import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XP55Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.configuration.transom.Name} port={this.props.configuration.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.056962, -0.006755, 0, -0.000045,
                    0.010608, 0.101644, 0, 0.000036,
                    0, 0, 1, 0,
                    232, 375, 0, 1
                ]}>
                <ConfiguratorImage boat="XP55" configuration={this.props.configuration.exterior} options={imageOptions} />
            </TransomConfigurator>
        );



        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>
                    <h1><Trans defaults='Summary' /></h1>
                    <h2><Trans defaults='Congratulations!' /></h2>
                    <p><Trans defaults='You have now configured the basics of an Xp 55. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>
                 

                    <PdfForm boat="xp55" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />


                    <ShareFrom configuration={this.props.configuration} boat="xp55" code={this.props.code} />
                    
                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP55Summary);


// WEBPACK FOOTER //
// ./src/XP55/XP55Summary.js